import * as Yup from 'yup';

// Helper schema for action-specific data validation
const actionDataSchemas = {
  api: Yup.object().shape({
    headers: Yup.object().shape({}).optional(),
    body: Yup.object().shape({}).optional(),
  }),
  transfer: Yup.object().shape({
    phoneNumber: Yup.string()
      .matches(/^\+?[1-9]\d{1,14}$/, 'Invalid phone number')
      .required('Phone number is required'),
    actionTime: Yup.string().required('Action trigger time is required'),
  }),
  sms: Yup.object().shape({
    message: Yup.string().required('SMS message is required'),
    actionTime: Yup.string().required('Action trigger time is required'),
  }),
  email: Yup.object().shape({
    subject: Yup.string().required('Email subject is required'),
    body: Yup.string().required('Email body is required'),
    actionTime: Yup.string().required('Action trigger time is required'),
  }),
  schedule: Yup.object().shape({
    date: Yup.string().required('Schedule date is required'),
  }),
  takeMessage: Yup.object().shape({
    email: Yup.string()
      .email('Invalid email format')
      .required('Email is required'),
  }),
};

export const personalizeSchema = Yup.object().shape({
  greeting: Yup.string().required('Greeting message is required'),

  identity: Yup.string().required('Assistant identity is required'),

  job: Yup.string().required('Job description is required'),

  selectedActions: Yup.array()
    .of(
      Yup.object().shape({
        type: Yup.string()
          .oneOf([
            'api',
            'transfer',
            'sms',
            'email',
            'schedule',
            'take-message',
          ])
          .optional(),

        data: Yup.mixed().when('type', {
          is: (type: string) => Object.keys(actionDataSchemas).includes(type),
          then: schema => {
            const parent = schema as any;
            return actionDataSchemas[
              parent.parent.type as keyof typeof actionDataSchemas
            ];
          },
        }),
      })
    )
    .default([]),
});
